import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import TrustedBy from '../components/TrustedBy';
import DiscoverServices from '../components/DiscoverServices';
import FeaturedProjects from '../components/FeaturedProjects';
import AboutStats from '../components/AboutStats';
import Banner from '../components/Banner';
import CreativeStudio from '../components/CreativeStudio';
import Testimonials from '../components/Testimonials';
import TeamSection from '../components/TeamSection';
import ServicesSection from '../components/ServicesSection';
import StatsSection from '../components/StatsSection';
import Footer from '../components/Footer';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when component mounts or location changes
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <TrustedBy />
      <DiscoverServices />
      <FeaturedProjects />
      <Banner position="home-after-stats" className='hidden md:block' />
      <AboutStats />
      <Banner position="home-after-stats" className='hidden max-md:block' />

      <TeamSection />
      {/* <ServicesSection /> */}
      {/* <StatsSection /> */}
      <CreativeStudio />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default Home;